/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component } from '@angular/core';
import { NotificationModel } from '../../../../../core/models';
import { NotifyService, UtilsService } from '../../../../../core/services';
import { WidgetBaseComponent } from '../widgetBase.component';
import { WidgetInterface } from '../../interfaces/widget.interface';
import { WidgetStateEnum } from '../../../../../core/enums';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-lb-widget-alerts',
    templateUrl: './alerts.widget.html',
    styleUrls: ['./alerts.widget.scss']
})

/**
 * Where are the alerts coming from?
 * The system notifications emitter
 * The bear
 */

export class AlertsWidgetComponent extends WidgetBaseComponent implements WidgetInterface {
    /**
     * Open enum to view
     */
    public WidgetStateEnum = WidgetStateEnum;

    /**
     * Set our default state
     */
    public state: WidgetStateEnum;

    /**
     * Store of all of our notifications
     */
    public notifications: NotificationModel[] = [];

    public loading: boolean = false;

    /**
     * Time elapsed since last alert converted to 's'.
     */
    public timeElapsed: string;

    /**
     * Store the id set by the setInterval() so we can clear it
     * on each new alert notification.
     */
    public setIntervalId: any;

    constructor(
        private notifyService: NotifyService,
        utils: UtilsService
    ) {

        super(utils);
        this.resetLocalVariables();
        this.notifyService.updateNotificationsEmitter
            .pipe(takeUntil(this.destroyed$))
            .subscribe(
                (notifications) => {
                    // Clear out our previous notifications
                    this.resetLocalVariables();
                    // Add all of our new notifications
                    for (const notification of notifications) {
                        if (notification.level === 1) {
                            this.notifications.push(notification);
                        }
                    }
                    this.notifications.reverse();
                    this.setState(this.notifications.length);
                    this.calcTimeDif();
                }
            );
        // Setup our socket listeners
        this.socketListeners();
    }

    /**
     * calc time ago
     */
    public calcTimeDif(): void {
        const date = this.getLastNotificationDate();
        clearInterval(this.setIntervalId);
        this.setIntervalId = setInterval(() => {
            this.timeElapsed = this.utils.timeDifference(new Date(), date, true);
        }, 1000);
    }

    /**
     * Get the notification for the alert to calculate the time elapsed
     */
    public getLastNotificationDate(): Date {
        const notification = this.notifications;
        if (notification.length) {
            return notification[0].date;
        }
    }

    /**
     * Define all of our socket listeners
     */
    public socketListeners() {
    }

    /**
     * Get all of our widget details
     */
    public getWidgetDetails(): void {
    }

    /**
     * Reset all of our local variables
     */
    public resetLocalVariables(): void {
        this.notifications = [];
        this.state = WidgetStateEnum.OK;
    }

    /**
     * Set the widget state
     */
    private setState(data): void {
        if (data > 0) {
            this.state = WidgetStateEnum.CRITICAL;
        } else {
            this.state = WidgetStateEnum.OK;
        }
    }
}
